$(function() {
	// 入力内容の確認ボタンの無効制御
	$('#register-agree-check').change(function() {
		let result = $(this).prop('checked');
		let btnObj = $('#register-confirm-btn');
		if(result) {
			btnObj.prop('disabled', false);
		} else {
			btnObj.prop('disabled', true);
		}
	});


    // 画像処理
    // 読み込んだ画像をimgにセットして、プレビューをcanvasにセットする
    var imageCanvasResize = function(file,prevElement,thumbWidth,thumbHeight) {
      return new Promise(function(resolve, reject) {
        let image = new Image();
        let fileReader = new FileReader();
        // 画像プレビュー
        fileReader.onload = function(e) {
          let img_src = prevElement.attr('src', fileReader.result);
          image.onload = function() {
            var width, height;
            if(image.width > image.height){
              // 横長の画像は横のサイズを指定値にあわせる
                let ratio = image.height/image.width;
              width = thumbWidth;
              height = thumbWidth * ratio;
            } else {
              // 縦長の画像は縦のサイズを指定値にあわせる
                let ratio = image.width/image.height;
              width = thumbHeight * ratio;
              height = thumbHeight;
            }

            // 画像が回転しているかチェック
            let options = {
              canvas:true,
              maxWidth: width,
              maxHeight: height,
            }

            // JavaScript-Load-Image
            loadImage.parseMetaData(file, function (data) {
              if (data.exif) {
                  // options の orientation は小文字。 exif.getの 'Orientation' は先頭大文字
                  // ここでcanvasの回転を指定している
                  options.orientation = data.exif.get('Orientation');
                  console.log('Orientation: ' + options.orientation);
              }
              // 以前のcanvasがあったら削除しておく
              prevElement.find("canvas").remove();
              // 画像の読み込み。
              loadImage(file, function(canvas) {
                  prevElement.append(canvas);
                  resolve(canvas);
              }, options);
            });
          }
          image.src = e.target.result;
        }
        fileReader.readAsDataURL(file);
      });
    }
    // canvasから画像を生成する
    var convertCanvasToBlob = function(canvas, fileType) {
      // canvasからbase64画像データを取得
      let base64 = canvas.toDataURL(fileType);
      // base64からBlobデータを作成
      let barr, bin, i, len;
      bin = atob(base64.split('base64,')[1]);
      len = bin.length;
      barr = new Uint8Array(len);
      i = 0;
      while (i < len) {
        barr[i] = bin.charCodeAt(i);
        i++;
      }
      blob = new Blob([barr], {type: fileType});
      console.log(blob);

      return blob;
    }

    // 画像を削除/戻す
    var setBaseImage = function(hiddenObj, prevParentElement) {
        prevParentElement.find("canvas").remove();

        // imgをデフォルト画像にセット
        prevParentElement.find("img").attr("src", "");
        prevParentElement.find("img").show();

        hiddenObj.val(null);
    }

    // 画像アップロード
    $('.file__up input[type="file"]').on("change",function() {
      var thisObj = $(this);
      var prevParentElement = $(thisObj.attr("data-preview-target"));
      var prevElement = $(thisObj.attr("data-preview-target")+" img");
      var orgPass     = prevElement.attr('src');
      var hiddenObj   = $(thisObj.attr("data-hidden-target"));
      var deleteObj   = $(thisObj.attr("data-delete-target"));
      var file = thisObj.prop('files')[0];

      if (!this.files.length){
        prevElement.attr('src', orgPass);
        alert("ファイルを選択して下さい。");
        return false;
      }

      let fileType = file.type;
      if (fileType.startsWith('image/')) {
          prevParentElement.removeClass("empty");
          imageCanvasResize(file,prevElement,1600,1600).then(function(canvasElement) {
            var blob = convertCanvasToBlob(canvasElement, fileType);

            // フォームデータ生成
            var formObj = new FormData();
            if (thisObj.val()!== '' )
              formObj.append("file",blob);
            else
              return false;

            // ajaxでサーバに送信
            var postData = {
              type: 'POST',
              dataType: 'json',
              data: formObj,
              processData: false,
              contentType: false,
            }
            $.ajax(
              "/api/image_upload/"+thisObj.attr("data-type"),
              postData
            )
            .done(function(data) {
              thisObj.val("");
              if(data.error) {
                alert("画像のアップロードに失敗しました");
                prevParentElement.addClass("empty");
              } else {
                hiddenObj.val(data.url);
                deleteObj.removeAttr("disabled");

                prevParentElement.show();
              }
            })
            .fail(function(data) {
              alert("画像のアップロードに失敗しました。");
              setBaseImage(hiddenObj,prevParentElement);
              prevParentElement.addClass("empty");
            });
          });
      }

      return false;
    });

    // 画像削除ボタン
    $('.file__delete').on("click",function() {
      let thisObj = $(this);
      let prevParentElement = $(thisObj.attr("data-preview-target"));
      let prevElement = $(thisObj.attr("data-preview-target")+" img");
      let hiddenObj = $(thisObj.attr("data-hidden-target"));

      if(thisObj.attr("disabled")) return false;
      if(!confirm("ファイルを削除します")) return false;

      thisObj.attr("disabled",true);
      setBaseImage(hiddenObj,prevParentElement);
      prevParentElement.hide();
    });

    // 会員種別の違いをモーダル表示
    $('#user-plan-link').on('click',function() {
        let thisObj = $(this);
        let modalObj = $(thisObj.data("target"));

        modalObj.modal();
		return false;
    });


    // 会員種別の違いのモーダルを閉じる
    $('#user-plan-close-link').on('click',function() {
        let thisObj = $(this);
        let modalObj = $(thisObj.data("target"));

		modalObj.modal('hide');
		return false;
    });



});